export class WaiverRequestFilter {
    id: string = "";
    clientId: string = "";
    corporateName: string = "";
}
